import {
    CLEAR_ATTACHMENTS_ALLOWED,
    IS_USER_ATTACHMENTS_ALLOWED,
} from "../../../enums/Request/currentRequestControls.types";

export const isAttachmentsAllowedAction = (data) => {
    console.log(data);
    return {
        type: IS_USER_ATTACHMENTS_ALLOWED,
        payload: data,
    }
}
export const clearAttachmentsAllowedAction = () => {
    return {
        type: CLEAR_ATTACHMENTS_ALLOWED,
    }
}
